import api from './api';

export const complianceAPI = {
  list: (params) => api.get('/api/compliance', { params }),
  create: (data) => api.post('/api/compliance', data),
  update: (id, data) => api.patch(`/api/compliance/${id}`, data),
  remove: (id) => api.delete(`/api/compliance/${id}`),
  dashboard: () => api.get('/api/compliance/dashboard'),
  workflows: () => api.get('/api/compliance/workflows'),
  listClientDeadlines: (clientId) => api.get(`/api/clients/${clientId}/compliance`),
  generateClientDeadlines: (clientId) => api.post(`/api/clients/${clientId}/compliance/generate`),
};

// Human-readable labels for per-type workflow stages (B#11).
export const WORKFLOW_STAGE_LABELS = {
  not_started: 'Not Started',
  gathering_data: 'Gathering Data',
  in_progress: 'In Progress',
  awaiting_client: 'Awaiting Client',
  awaiting_documents: 'Awaiting Documents',
  awaiting_client_approval: 'Awaiting Approval',
  ready_to_lodge: 'Ready to Lodge',
  review: 'Review',
  reported: 'Reported',
  lodged: 'Lodged',
  payment_pending: 'Payment Pending',
  paid: 'Paid',
  assessed: 'Assessed',
};

export const tasksAPI = {
  list: (params) => api.get('/api/tasks', { params }),
  get: (id) => api.get(`/api/tasks/${id}`),
  create: (data) => api.post('/api/tasks', data),
  update: (id, data) => api.patch(`/api/tasks/${id}`, data),
  updateStatus: (id, status) => api.patch(`/api/tasks/${id}/status`, null, { params: { status } }),
};
